/**
 * DJI México - Footer 埋点（全站）
 * ==================================================================
 * 严格按《数据埋点定义文档》Footer 实施清单表（3 行）实施，不多不少：
 *
 *   Footer 在线客服入口   customer_service_open   P0 L3   ← 本文件
 *   Footer Newsletter     newsletter_subscribe    P0 L3   ← snippets/dji-footer-subscribe.liquid
 *   Footer 联系信息       contact_action_click    P2 L3   ← 本文件
 *
 * Newsletter 的成功判定依赖 Liquid 的 form.posted_successfully?，
 * 因此留在组件内联脚本里，本文件只处理另外两行。
 *
 * 站内实况（snippets/dji-footer-features.liquid + sections/footer-group.json）：
 *   "Chat en vivo" 是 <a class="dji-ftf__link" href="/pages/chat">，
 *   inline onclick 调用 window.open(this.href,'dji-zoho-chat',...) 并 return false。
 *   → 弹窗被浏览器拦截时 window.open 返回 null，聊天窗口并没有打开。
 *   所以这里劫持 window.open 取返回值来判定"实际成功打开"，
 *   而不是点击即上报。
 */
(function (w, d) {
  'use strict';

  var DL = w.DJIDataLayer;
  if (!DL) return;

  var C = {
    service:    { component_id: 'footer_customer_service', placement: 'footer_top_service' },
    contact:    { component_id: 'footer_contact',          placement: 'footer_bottom' },
    newsletter: { component_id: 'footer_newsletter',       placement: 'footer_subscription' }
  };

  var SEL = {
    footer:    'footer, .footer, [class*="dji-ftf"], [class*="dji-fb"], #shopify-section-footer',
    chatLink:  'a.dji-ftf__link[href*="/chat"], a[href*="/pages/chat"], a[href*="zoho"], a[href*="salesiq"]',
    phoneLink: 'a[href^="tel:"]',
    mailLink:  'a[href^="mailto:"]'
  };

  /** 入口文案 → entry_label（表格示例值 chat_en_vivo） */
  function entryLabel(el) {
    var t = (el && el.innerText ? el.innerText : '').trim().toLowerCase();
    if (!t) return 'chat';
    return t.replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '').slice(0, 40) || 'chat';
  }

  function now() { return Date.now ? Date.now() : new Date().getTime(); }

  function base(cfg, extra) {
    var out = {
      page_type: DL.ctx.page_type,
      component_id: cfg.component_id,
      placement: cfg.placement
    };
    for (var k in (extra || {})) out[k] = extra[k];
    return out;
  }

  function fireServiceOpen(label) {
    DL.push('customer_service_open', base(C.service, {
      entry_label: label,
      service_type: 'live_chat'
    }));
  }

  /* ---------------------------------------------------------------
   * 劫持 window.open：只在"客服入口被点击后的短窗口内"生效，
   * 且只在返回真实 window 对象（未被拦截）时上报。
   * ------------------------------------------------------------- */
  var pending = null;   // { label: string, until: number }

  (function hookOpen() {
    var native = w.open;
    if (typeof native !== 'function' || native.__djiHooked) return;
    var patched = function (url, name) {
      var win = native.apply(this, arguments);
      try {
        if (pending && now() <= pending.until) {
          var isChat = /chat|zoho|salesiq/i.test(String(url || '') + '|' + String(name || ''));
          if (isChat && win) fireServiceOpen(pending.label);
          pending = null;
        }
      } catch (e) { /* 埋点绝不影响客服窗口本身 */ }
      return win;
    };
    patched.__djiHooked = true;
    try { w.open = patched; } catch (e) { /* 某些环境 window.open 只读 */ }
  })();

  /* 捕获阶段：inline onclick 在冒泡阶段执行，这里必须先于它登记 pending */
  d.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    if (!t.closest(SEL.footer)) return;

    var chat = t.closest(SEL.chatLink);
    if (chat) {
      if (!DL.isInteractive(chat)) return;
      var label = entryLabel(chat);
      pending = { label: label, until: now() + 1500 };
      /* 非弹窗形态（后台把 f*_link_popup 关掉时）：这是一次正常跳转，
         跳到客服页即视为窗口打开；仍要求这次点击确实会成功跳转。 */
      DL.afterTick(function () {
        if (!pending) return;               // window.open 分支已经上报过
        if (!DL.clickWillSucceed(evt, chat)) { pending = null; return; }
        pending = null;
        fireServiceOpen(label);
      });
      return;
    }

    /* 联系信息：只有可拨打 / 可发送邮件的链接才算，纯文本展示不触发 */
    var tel = t.closest(SEL.phoneLink);
    var mail = tel ? null : t.closest(SEL.mailLink);
    if (!tel && !mail) return;
    var link = tel || mail;
    if (!DL.isInteractive(link)) return;
    DL.afterTick(function () {
      DL.push('contact_action_click', base(C.contact, {
        contact_type: tel ? 'phone' : 'email'
        /* 号码与邮箱本身属于 PII，不进 dataLayer */
      }));
    });
  }, true);

  /* ================================================================ */
  /* Footer Newsletter · newsletter_subscribe                          */
  /* ================================================================ */

  /**
   * 事件在这里发、不在 Liquid 里内联发：
   * Liquid 那段是 body 内联脚本，执行时 <head> 的 defer 核心库还没跑，
   * window.DJIDataLayer 必然 undefined —— 上一版 100% 走降级分支裸推 dataLayer，
   * 公共字段全缺。本文件是 defer 资源，核心库一定已就绪。
   *
   * 归因：首页 hero 与 Footer 的订阅表单 form_type 都是 customer，
   * Shopify 让同 form_type 的所有表单同时 posted_successfully? 为真，
   * 回跳参数也都是 ?customer_posted=true，只能靠提交时写入的来源标记区分。
   */
  /* ⚠️ 与首页用不同的键：两个表单 form_type 都是 customer，
     任一方提交成功时两处的成功标记都会渲染。共享一个键的话，
     先执行的模块会把另一方的记录删掉。 */
  var NL_KEY = 'dji_nl_footer';

  function emitNewsletter() {
    /* ⚠️ 键必须无条件消费，不能只在成功时删：
       提交失败时页面渲染的是 form.errors、没有成功标记，若此时把键留着，
       用户 2 分钟内改从首页 hero 订阅成功 —— 那一页同样会渲染 Footer 的成功标记
       （同 form_type: customer）—— 这条残留记录就会被误认领，
       一次订阅变成 generate_lead + newsletter_subscribe 两条，且来源错。 */
    var rec = null;
    try {
      rec = JSON.parse(w.sessionStorage.getItem(NL_KEY) || 'null');
      if (rec) w.sessionStorage.removeItem(NL_KEY);
    } catch (e) {}

    if (!d.querySelector('[data-dji-newsletter-success]')) return;
    if (!rec || rec.src !== 'footer') return;

    /* 没有来源记录说明这次成功不是本会话从 Footer 提交的
       （例如用户收藏了带 ?customer_posted=true 的 URL 再打开），不上报 */
    if (Date.now() - (rec.at || 0) > 120000) return;
    if (!DL.onceSession('footer_newsletter|' + rec.at)) return;

    DL.push('newsletter_subscribe', base(C.newsletter, {
      form_id: 'footer_newsletter',
      subscription_status: 'success',
      consent_checked: rec.consent === null ? undefined : !!rec.consent
      /* 邮箱不进 dataLayer */
    }));
  }

  emitNewsletter();

  DL.log('footer tracking ready');
})(window, document);
